import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';

export function CustodianConfirmModal({
  open,
  title,
  description,
  confirmLabel,
  busy = false,
  error = '',
  onCancel,
  onConfirm,
}) {
  return (
    <Modal
      open={open}
      onClose={busy ? undefined : onCancel}
      title={title}
      footer={
        <>
          <Button variant="ghost" type="button" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="navy" type="button" onClick={onConfirm} disabled={busy}>
            {busy ? 'Working…' : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm leading-relaxed text-umb-neutral-dark/85">{description}</p>
      {error ? (
        <p className="mt-3 text-sm text-umb-error" role="alert">
          {error}
        </p>
      ) : null}
    </Modal>
  );
}
